var map = {
	"./1c_icon.svg": "1782",
	"./actions/createEducation.svg": "177c",
	"./arrow_down.svg": "4b1a",
	"./arrow_left.svg": "93ae",
	"./arrow_right.svg": "e45f",
	"./arrow_top.svg": "4e1c",
	"./arrow_top_icon.svg": "39a0",
	"./arrow_twin.svg": "feb7",
	"./attach_icon.svg": "5d34",
	"./bell.svg": "3d56",
	"./birthday_action.svg": "f36e",
	"./building.svg": "a528",
	"./burger.svg": "ada2b",
	"./buying.svg": "885f",
	"./buying_title.svg": "cc83",
	"./calendar.svg": "b8bd",
	"./calendar_title.svg": "1e83",
	"./callbacks.svg": "7299",
	"./callbacks_title.svg": "f2f0",
	"./card.svg": "5d4a",
	"./cart_all.svg": "6070",
	"./cart_big.svg": "7e99",
	"./check-white.svg": "5131",
	"./check.svg": "7bae",
	"./clear_cache.svg": "7b01",
	"./client_add.svg": "98b3",
	"./clients.svg": "b53a",
	"./clients_all.svg": "fa51",
	"./clients_title.svg": "3564",
	"./close_icon.svg": "48e4",
	"./delivery.svg": "4a78",
	"./delivery_map.svg": "339e",
	"./delivery_title.svg": "267a",
	"./desktop_title.svg": "5c97",
	"./doc.svg": "3f7d",
	"./doc_download_icon.svg": "b611",
	"./document_icon.svg": "8f12",
	"./dots_icon.svg": "e8eb",
	"./download_icon.svg": "1421",
	"./education.svg": "6228",
	"./education_add.svg": "57c9",
	"./education_title.svg": "7faa",
	"./employee.svg": "9234",
	"./employee_all.svg": "612a",
	"./employees_title.svg": "6ff8",
	"./eye.svg": "7364",
	"./eye_close.svg": "be84",
	"./file_icon.svg": "2f83",
	"./filter.svg": "2376",
	"./flag_en.svg": "ec37",
	"./flag_ru.svg": "c12e",
	"./goods.svg": "2231",
	"./goods_title.svg": "abd7",
	"./highest_icon.svg": "2a8a",
	"./info_all.svg": "0395",
	"./info_icon.svg": "16fe",
	"./info_not_processed.svg": "19b9",
	"./info_processed.svg": "43b6",
	"./logo.svg": "5b1c",
	"./logo_big.svg": "0a7b",
	"./mail.svg": "3ae9",
	"./mails_title.svg": "ae9d",
	"./mango.svg": "fbd8",
	"./mango_title.svg": "8f41",
	"./monitor.svg": "2477",
	"./monitor_title.svg": "f802",
	"./move.svg": "d8c1",
	"./negative.svg": "4ebd",
	"./option.svg": "e75f",
	"./orders.svg": "3ca5",
	"./orders_title.svg": "8dc0",
	"./pause_icon.svg": "c232",
	"./personal_title.svg": "b63d",
	"./phone.svg": "c3bb",
	"./play_icon.svg": "4aab",
	"./positive.svg": "d466",
	"./reports.svg": "aa1a",
	"./reports_title.svg": "3dff",
	"./search.svg": "d103",
	"./seo.svg": "4a13",
	"./seo_title.svg": "6f63",
	"./settings_small.svg": "f1d8",
	"./storage.svg": "83a1",
	"./storage_title.svg": "9e72",
	"./success_red.svg": "f88d",
	"./task_add_icon.svg": "1c90",
	"./tasks.svg": "e882",
	"./tasks_add.svg": "ed74",
	"./tasks_title.svg": "170d",
	"./trash_icon.svg": "5e1d",
	"./user.svg": "6aed",
	"./world.svg": "0257",
	"./write_icon.svg": "3080"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";